import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import LOGO from 'src/assets/images/Talent500.svg';
import { sessionActions } from 'src/redux/modules/session/creator';
import { openRoutes, protectedRoutes } from 'src/routes';

import { searchActions } from 'src/redux/modules/search/creator';
import {
  NavbarContainer,
  NavbarWrapper,
  NavbarLogoContainer,
  NavbarLogo,
  NavbarListItemContainer,
  ActiveStateActiveJobs,
  InactiveStateActiveJobs,
  ActiveStateSearch,
  InactiveStateSearch,
  ActiveStateTracker,
  InactiveStateTracker,
  LogoutLink,
} from './styles';

function Navbar({ location, logout, resetSearchFormData }) {
  const activeLink = `/${ location.pathname.split('/')[1]}`;
  return (
    <NavbarContainer>
      <NavbarWrapper>
        <NavbarListItemContainer>
          <NavbarLogoContainer as={Link} to={openRoutes.root}>
            <NavbarLogo width="120px" src={LOGO} alt="company-logo" />
          </NavbarLogoContainer>
          {activeLink === protectedRoutes.activeJobs
              ? <ActiveStateActiveJobs to={protectedRoutes.activeJobs}>Active Jobs</ActiveStateActiveJobs>
              : <InactiveStateActiveJobs to={protectedRoutes.activeJobs}>Active Jobs</InactiveStateActiveJobs>}
          {activeLink === protectedRoutes.search
              ? <ActiveStateSearch to={protectedRoutes.search}><div onClick={() => resetSearchFormData()}>Search</div></ActiveStateSearch>
              : <InactiveStateSearch to={protectedRoutes.search}><div onClick={() => resetSearchFormData()}>Search</div></InactiveStateSearch>}
          {activeLink === protectedRoutes.tracker
              ? <ActiveStateTracker to={protectedRoutes.tracker}>Tracker</ActiveStateTracker>
              : <InactiveStateTracker to={protectedRoutes.tracker}>Tracker</InactiveStateTracker>}
        </NavbarListItemContainer>
        <LogoutLink
          onClick={logout}
        >
          Logout
        </LogoutLink>
      </NavbarWrapper>
    </NavbarContainer>
  );
}
Navbar.propTypes = {};


const mapStateToProps = ({ session }) => ({
  user: session.user,
});

const mapDispatchToProps = {
  logout: sessionActions.userLogout,
  resetSearchFormData: searchActions.resetSearchFormData,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Navbar));
